import { cn } from '@/lib/utils';

interface StalenessBadgeProps {
  score: number | null;
  className?: string;
}

export function StalenessBadge({ score, className }: StalenessBadgeProps) {
  if (score === null) return null;

  const color = score <= 30
    ? 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300'
    : score <= 60
      ? 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300'
      : 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300';

  const label = score <= 30 ? 'Fresh' : score <= 60 ? 'Aging' : 'Stale';

  return (
    <span className={cn('px-1.5 py-0.5 rounded text-[10px] font-medium', color, className)}>
      {label} ({score})
    </span>
  );
}
